import { anvil } from '@ada-anvil/sdk-client';

try {
  anvil.config.authenticate(process.env.REACT_APP_ANVIL_TOKEN);
} catch {
  console.log('Authentication failed');
}

export default anvil;
